<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="vx-row">
      <vx-card>
        <vs-table
          :max-items="paginationItems[1]"
          pagination
          :data="manageCodesList"
          :description="false"
          @selected="handleSelected"
          search
          :description-items="paginationItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("system.label.ManageCodes") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push('/createManageCodes').catch(() => {})"
                size="small"
                >{{ $t("system.label.CreateCode") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("system.label.Module") }}</vs-th>
            <vs-th>{{ $t("system.label.Name") }}</vs-th>
            <vs-th>{{ $t("system.label.Description") }}</vs-th>
            <vs-th>{{ $t("system.label.SystemDefined") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("system.label.Action") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="manageCodesList"
              v-for="(manageCodesList, index) in data"
            >
              <vs-td :data="manageCodesList.module">{{
                manageCodesList.module
              }}</vs-td>
              <vs-td :data="manageCodesList.name">{{
                manageCodesList.name
              }}</vs-td>
              <vs-td :data="manageCodesList.description">{{
                manageCodesList.description
              }}</vs-td>
              <vs-td :data="manageCodesList.systemDefined">{{
                manageCodesList.systemDefined
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('system.label.Edit')"
                    class="icon_row"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editManageCOdes(manageCodesList.id)"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('system.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deletePopup = true;
                      delId = manageCodesList.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deletePopup"
      :title="$t('system.label.ManageCode')"
      @deletePressed="deleteCurrencyData(delId)"
      @cancelPressed="deletePopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapGetters({
      manageCodesList: "manageCodes/getManageListDataList",
    }),
  },
  methods: {
    async getManageCodesData() {
      this.loading = true;
      try {
        await this.$store.dispatch("manageCodes/setManageCodesData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteCurrencyData(id) {
      try {
        await this.$store.dispatch(
          "manageCodes/deleteManageCodesDataAction",
          id
        );
        this.$vs.notify({
          title: "Successfully Deleted!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        this.getManageCodesData();
        this.deletePopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    handleSelected(manageCodesList) {
      this.$router.push({
        path: `/viewManageCodes/${manageCodesList.id}`}).catch(() => {});
    },
    editManageCOdes(id) {
      this.$router.push(`/editManageCodes/${id}`);
    },
  },
  mounted() {
    this.getManageCodesData();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
